export default "__VITE_ASSET__y3q8UIXa__"